var render = function () {
  var _vm$work, _vm$work$imgs, _vm$work$imgs$, _vm$work2, _vm$work2$imgs, _vm$work2$imgs$, _vm$work3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "tile": "",
      "to": "/auction-works/".concat(_vm.work._id)
    }
  }, [_c('v-img', {
    class: {
      'v-sheet--outlined': !((_vm$work = _vm.work) === null || _vm$work === void 0 ? void 0 : (_vm$work$imgs = _vm$work.imgs) === null || _vm$work$imgs === void 0 ? void 0 : (_vm$work$imgs$ = _vm$work$imgs[0]) === null || _vm$work$imgs$ === void 0 ? void 0 : _vm$work$imgs$.url)
    },
    attrs: {
      "src": (_vm$work2 = _vm.work) === null || _vm$work2 === void 0 ? void 0 : (_vm$work2$imgs = _vm$work2.imgs) === null || _vm$work2$imgs === void 0 ? void 0 : (_vm$work2$imgs$ = _vm$work2$imgs[0]) === null || _vm$work2$imgs$ === void 0 ? void 0 : _vm$work2$imgs$.url,
      "aspect-ratio": 1 / 1,
      "width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-overlay', {
          attrs: {
            "absolute": "",
            "dark": "",
            "color": "transparent"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey",
            "size": "40"
          }
        }, [_vm._v("mdi-image-broken")])], 1)];
      },
      proxy: true
    }])
  }), _c('v-card-title', {
    staticClass: "px-0 py-20"
  }, [_vm._v(_vm._s((_vm$work3 = _vm.work) === null || _vm$work3 === void 0 ? void 0 : _vm$work3.subject))]), _c('v-divider', {
    staticClass: "primary"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }